import axios from 'axios'
import store from './store/index'
import { InfluxDB } from 'influx'

// const API_URL = window.env.API_URL || "https://approval.dart-dev.cirrus.pw/api"
const API_URL = window.env.API_URL || "http://localhost:8000/api"

const INFLUX_CONFIG = {
 host: window.env.INFLUXDB_HOST || '',
 port: '443',
 protocol: 'https',
 database: window.env.INFLUXDB_DATABASE || '',
 username: window.env.INFLUXDB_USER || '',
 password: window.env.INFLUXDB_PASSWORD || '',
}
const influx = new InfluxDB(INFLUX_CONFIG)

const approvalsApi = axios.create({
  baseURL: API_URL,
  headers: {
    authorization: `JWT ${store.state.auth.token}`
  }
})

function ensureAuthToken () {
  approvalsApi.defaults.headers.authorization = `JWT ${store.state.auth.token}`
}


export async function getDocuments (params, format='') {
  ensureAuthToken()
  const reqConfig = { params }
  if (format === '.xls') {
    reqConfig.responseType = 'blob'
  }
  const r = await approvalsApi.get(`/staff/documents${format}`, reqConfig)
  if (format !== '.xls') {
    r.data.results.map(
      // add logs-related fields (so they aren't undefined and are reactive)
      doc => {
        doc.busyLoadingLogs = false
        doc.busyLoadingDetails = false
        doc.logs = []
      }
    )
  }

  return r.data
}

export async function getDocument (id) {
  ensureAuthToken()
  const r = await approvalsApi.get(`/staff/documents/${id}`)
  return r.data
}

export async function getStats ({ date_start, date_end }) {
  ensureAuthToken()
  const reqData = { params: { date_start, date_end } }
  const resp = await approvalsApi.get('/staff/stats', reqData)
  return resp.data
}

export async function getUserInfo () {
  const resp = await approvalsApi.get(`/staff/user`)
  return resp.data
}


export async function getNewToken (username, password) {
  const resp = await approvalsApi.post(`/staff/jwt/obtain-token`, { username, password })
  return resp.data.token
}


export async function getRefreshedToken (token) {
  const resp = await approvalsApi.post(`/staff/jwt/refresh-token`, { token })
  return resp.data.token
}


export async function requeueDocuments (docsList) {
  ensureAuthToken()
  const reqData = { documents : docsList }
  const resp = await approvalsApi.post('/staff/documents/requeue', reqData)
  return resp.data
}


export async function failDocument(id) {
  ensureAuthToken()
  const reqData = {"documents": [`${id}`]}
  const resp = await approvalsApi.post('/staff/documents/fail', reqData)
  return resp.data
}


export async function requeueDocumentsRange ({ date_start, date_end, docs_type }) {
  ensureAuthToken()
  const reqData = { date_start, date_end, docs_type }
  const resp = await approvalsApi.post('/staff/documents/requeue', reqData)
  return resp.data
}

export async function getLogs(taskId) {
  ensureAuthToken()
  const resp = await approvalsApi.get(`/staff/documents/get-logs/${taskId}`)  
  return resp.data.map(item => (eval('(' + item.message + ')')))
}

export async function fetchInfluxEvents (groupBy='10m', startTime='6h', worker=null) {
  return influx
    .query('SELECT ' +
                    'COUNT("task_failed") AS "failed", ' +
                    'COUNT("task_started") AS "started", ' +
                    'COUNT("task_finished") AS "finished", ' +
                    'COUNT("task_enqueued") AS "enqueued" ' +
           'FROM approvals_app_events ' +
           `WHERE time >= (now() - ${startTime}) ` +
           (worker ? `AND "worker" = '${worker}' ` : '') +
           `GROUP BY time(${groupBy}) fill(null);`)
}
